/* Ability Warehouse — shared product index: loads the catalogue list once, matches search text, renders cards */
(function () {
  'use strict';
  if (window.CWIndex) return;
  var cfg = window.CW || {};
  var TTL = 20 * 60 * 1000;
  var mem = {};

  function money(c) {
    return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format((c || 0) / 100);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function cacheGet(k) {
    try { var raw = sessionStorage.getItem(k); if (!raw) return null; var o = JSON.parse(raw); if (Date.now() - o.t > TTL) return null; return o.d; } catch (e) { return null; }
  }
  function cacheSet(k, d) { try { sessionStorage.setItem(k, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {} }

  function prep(it) {
    // per = the price shown on cards (what the viewer pays); products are sold per unit
    it.per = it.p;
    it.ul = '';
    it.url = '/products/' + it.h;
    var tagText = (it.tg || []).join(' ').replace(/-/g, ' ');
    // v33: product type and vendor are searchable too (both arrive from collection.index.liquid)
    it.hay = [it.t, it.br, it.wr, it.wd, it.sh, it.mt, it.uf, it.nd, it.pt, it.vn, tagText].join(' ').toLowerCase().replace(/\s*x\s*/g, 'x');
    it.tl = it.t.toLowerCase().replace(/\s*x\s*/g, 'x');
    return it;
  }

  /* src: collection url, e.g. /collections/all */
  function load(src) {
    src = src || '/collections/all';
    if (mem[src]) return mem[src];
    var key = 'cwidx:' + (cfg.v || '') + (cfg.member ? 'm' : 'g') + src;
    var cached = cacheGet(key);
    if (cached) { mem[src] = Promise.resolve(cached.map(prep)); return mem[src]; }
    var sep = src.indexOf('?') > -1 ? '&' : '?';
    var get = function (n) {
      return fetch(src + sep + 'view=index&page=' + n, { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    };
    mem[src] = get(1).then(function (first) {
      var rest = [];
      for (var n = 2; n <= first.pages; n++) rest.push(get(n));
      return Promise.all(rest).then(function (pages) {
        var all = first.items;
        pages.forEach(function (p) { all = all.concat(p.items); });
        cacheSet(key, all);
        return all.map(prep);
      });
    }).catch(function (e) { delete mem[src]; throw e; });
    return mem[src];
  }

  var STOP = { the: 1, a: 1, an: 1, for: 1, and: 1, in: 1, with: 1, of: 1, to: 1, my: 1, i: 1, need: 1, product: 1, products: 1 };
  var SYN = {
    toilet: ['toilet', 'commode', 'toileting'], loo: ['toilet', 'commode'], commode: ['commode', 'toilet'],
    shower: ['shower', 'bath'], bath: ['bath', 'shower'], bathroom: ['bathroom', 'shower', 'bath'],
    walker: ['walker', 'rollator', 'walking frame'], rollator: ['rollator', 'walker'], frame: ['frame', 'walker'],
    stick: ['stick', 'cane'], cane: ['cane', 'stick'], wheelchair: ['wheelchair'], scooter: ['scooter'],
    rail: ['rail', 'grab bar', 'grab rail'], grab: ['grab', 'rail'], bar: ['bar', 'rail'],
    reacher: ['reacher', 'reaching', 'pick up'], grabber: ['reacher', 'grabber', 'pick up'],
    pads: ['pad', 'pads', 'incontinence'], nappies: ['nappies', 'nappy', 'briefs', 'incontinence'], nappy: ['nappies', 'nappy', 'briefs'],
    brace: ['brace', 'support', 'splint'], support: ['support', 'brace'], knee: ['knee'], back: ['back', 'lumbar'], wrist: ['wrist', 'hand'],
    bed: ['bed', 'overbed', 'mattress'], chair: ['chair', 'seat', 'seating'], seat: ['seat', 'chair'], cushion: ['cushion', 'pressure'],
    lift: ['lift', 'riser', 'recliner'], riser: ['riser', 'lift'], recliner: ['recliner', 'lift chair'],
    smart: ['smart', 'voice', 'sensor'], alarm: ['alarm', 'alert', 'sensor'], fall: ['fall', 'falls', 'alert'], falls: ['fall', 'falls'],
    grey: ['grey', 'gray'], gray: ['grey', 'gray'], bariatric: ['bariatric', 'heavy duty', 'wide'], wide: ['wide', 'bariatric'],
    kids: ['kids', 'children', 'child', 'youth'], ramp: ['ramp', 'threshold']
  };
  function tokens(q) {
    return String(q || '').toLowerCase().replace(/(\d)\s*(x|×|by)\s*(\d)/g, '$1x$3').replace(/[^\w\s.×-]/g, ' ').split(/\s+/)
      .filter(function (t) { return t && !STOP[t]; });
  }
  function score(it, toks) {
    var s = 0;
    for (var i = 0; i < toks.length; i++) {
      var opts = SYN[toks[i]] || [toks[i]], best = 0;
      for (var j = 0; j < opts.length; j++) {
        var o = opts[j];
        if (it.tl.indexOf(o) > -1) best = Math.max(best, (' ' + it.tl).indexOf(' ' + o) > -1 ? 4 : 3);
        else if (it.hay.indexOf(o) > -1) best = Math.max(best, 1);
      }
      if (!best) return 0;
      s += best;
    }
    return s + (it.a ? 0.5 : 0);
  }
  function search(items, q) {
    var toks = tokens(q);
    if (!toks.length) return items.slice();
    var out = [];
    items.forEach(function (it, i) { var s = score(it, toks); if (s) out.push({ it: it, s: s, i: i }); });
    out.sort(function (a, b) { return b.s - a.s || a.i - b.i; });
    return out.map(function (o) { return o.it; });
  }

  /* ---------- v33: typo-tolerant search ----------
     Each query token of 5+ letters that matches nothing is swapped for the closest word in the items' vocabulary
     (Levenshtein distance ≤ 1). Shorter tokens are left alone: one wrong letter in "bed" is a different word. */
  function lev1(a, b) {
    // true when a and b are within one edit (substitution, insertion or deletion)
    if (a === b) return true;
    var la = a.length, lb = b.length;
    if (Math.abs(la - lb) > 1) return false;
    var i = 0, j = 0, edits = 0;
    while (i < la && j < lb) {
      if (a[i] === b[j]) { i++; j++; continue; }
      if (++edits > 1) return false;
      if (la === lb) { i++; j++; } else if (la > lb) i++; else j++;
    }
    return edits + (la - i) + (lb - j) <= 1;
  }
  var vocabCache = null, vocabFor = null;
  function vocab(items) {
    if (vocabFor === items && vocabCache) return vocabCache;
    var seen = {};
    items.forEach(function (it) { it.hay.split(/[^a-z0-9]+/).forEach(function (w) { if (w.length >= 4) seen[w] = 1; }); });
    vocabFor = items; vocabCache = Object.keys(seen);
    return vocabCache;
  }
  function fuzzyQuery(items, q) {
    // returns a corrected query string, or '' when nothing needed correcting
    var toks = tokens(q), words = null, changed = false;
    var out = toks.map(function (t) {
      if (t.length < 5 || SYN[t]) return t;
      var hit = items.some(function (it) { return it.hay.indexOf(t) > -1; });
      if (hit) return t;
      words = words || vocab(items);
      for (var i = 0; i < words.length; i++) if (lev1(t, words[i])) { changed = true; return words[i]; }
      return t;
    });
    return changed ? out.join(' ') : '';
  }
  function searchFuzzy(items, q) {
    // exact search first; when it finds nothing, retry with one-letter corrections. Returns {items, corrected}
    var r = search(items, q);
    if (r.length || !tokens(q).length) return { items: r, corrected: '' };
    var fq = fuzzyQuery(items, q);
    if (!fq) return { items: r, corrected: '' };
    return { items: search(items, fq), corrected: fq };
  }

  function priceHTML(it) {
    /* One price, plus what members save (green chip). Members see their price with a "Member price" chip. No retail or struck-through prices. */
    var tick = '<svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true"><path d="M20 6 9 17l-5-5" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var noSale = (it.tg || []).indexOf('no-sale') > -1, save = it.per - it.m, show = !noSale && save > 0;
    if (cfg.member && show) return '<div class="price price--mf price--compact"><span class="price__now">' + money(it.m) + '</span><span class="price__mem">' + tick + 'Member price</span></div>';
    if (show) return '<div class="price price--mf price--compact"><span class="price__now price__now--mem">' + money(it.m) + '</span><span class="price__mem price__mem--cond">Member price · ' + money(it.per) + ' without</span></div>';
    return '<div class="price price--mf price--compact"><span class="price__now">' + money(it.per) + '</span></div>';
  }
  (function () {
    if (document.getElementById('cw-price-mf')) return;
    var st = document.createElement('style'); st.id = 'cw-price-mf';
    st.textContent = '.price--mf{display:grid;justify-items:start;gap:3px}.price--mf .price__now{font-variant-numeric:tabular-nums}.price--mf .price__mem{display:inline-flex;align-items:center;gap:4px;padding:2px 7px;border-radius:8px;background:#E8F4EC;color:#1B7F4B;font-size:12px;font-weight:800;line-height:1.3}.price--mf .price__now--mem{color:#D7141E}.price--mf .price__mem--cond{background:none;color:#5B6573;padding:0;font-weight:700}';
    (document.head || document.documentElement).appendChild(st);
  })();
  function img(src, w) { return src ? src.replace(/width=\d+/, 'width=' + w) : ''; }
  function card(it) {
    var pct = it.r > it.p ? Math.round((it.r - it.p) * 100 / it.r) : 0;
    var spec = [it.wr, it.wd, it.sh ? 'seat ' + it.sh : ''].filter(Boolean).join(' · ');
    var isNew = (it.tg || []).indexOf('new') > -1;
    return '<article class="card"><a class="card__media" href="' + it.url + '" aria-label="' + esc(it.t) + '">' +
      (it.im ? '<img class="card__img" loading="lazy" src="' + img(it.im, 400) + '" srcset="' + img(it.im, 240) + ' 240w, ' + img(it.im, 400) + ' 400w, ' + img(it.im, 600) + ' 600w" sizes="(min-width: 990px) 22vw, 50vw" alt="' + esc(it.t) + '" width="400" height="400">' : '<span class="card__img placeholder"></span>') +
      '<span class="card__badges">' + (it.br ? '<span class="badge">' + esc(it.br) + '</span>' : '') + (isNew ? '<span class="badge">New</span>' : '') + '</span>' +
      (pct > 0 ? '<span class="sticker">−' + pct + '%</span>' : '') + '</a>' +
      '<div class="card__body"><a class="card__title" href="' + it.url + '">' + esc(it.t) + '</a>' +
      (spec ? '<p class="card__spec">' + esc(spec) + '</p>' : '') +
      (it.a ? '' : '<p class="stock stock--out"><span class="dot"></span>Sold out</p>') +
      priceHTML(it) + '</div><div class="card__actions"><a class="btn btn--red btn--sm card__cta" href="' + it.url + '">View &amp; buy <span aria-hidden="true">→</span></a></div></article>';
  }

  window.CWIndex = { load: load, search: search, searchFuzzy: searchFuzzy, fuzzyQuery: fuzzyQuery, tokens: tokens, card: card, priceHTML: priceHTML, money: money, esc: esc, img: img };
})();
